import React from 'react';
import './DynaInput.scss';

const DynaInput = (props) => {

    return (

        <div className={`label-input ${props.className !== undefined ? props.className : ""}`}>
            <label htmlFor={props.name}>{props.label}</label>
            {
                props.typeMode === 'input' ?
                    <input id={props.id}
                           name={props.name}
                           type={props.type}
                           placeholder={props.placeholder}
                           value={props.value}
                           disabled={props.disabled}
                           onChange={props.onChange}
                           style={props.inputStyle}/> :
                    props.typeMode === 'select' ?
                        <select id={props.id}
                                name={props.name}
                                value={props.value}
                                onChange={props.onChange}>
                            <option value="" selected disabled hidden>انتخاب کنید ...</option>
                            {props.selectOption?.map((v, index) =>
                                <option value={v.value} key={"op" + index}>{v.label}</option>
                            )}
                        </select> :
                        props.typeMode === "uploadFile" ?
                            <label className={props.fileInputClass}>
                                <input type={'file'}
                                       id={props.id}
                                       name={props.name}
                                       onChange={props.onChange}/>

                                <div className="in-input-file">
                                    <p>{props.fileName}</p>
                                    {props.uploadIcon}
                                </div>

                            </label> :
                            props.typeMode === 'textarea' ?
                                <textarea id={props.id}
                                          name={props.name}
                                          placeholder={props.placeholder}
                                          value={props.value}
                                          style={props.style}
                                          disabled={props.disabled}
                                          onChange={props.onChange}/> :""
            }

        </div>
    );
};
export default DynaInput;